import { HttpProvider } from "../http/http.provider";
import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { createFormData } from "../util/utilities";
import { IHttpRequestConfig } from "..";
import { INewProperty,
 INewPropertyContractDocument,
 IProperty,
 IPropertyContractDocument,
 IPropertyResponse,
 IPropertySuite } from "../PropertyService";
import { INewPropertyRentDocument } from "./property.interface";

export class PropertyDelegate
{
 
    constructor(private http: HttpProvider)
    {
    }

    public getAllProperties(orgId: string): Observable<IPropertyResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.PROPERTY.GET, null, config).pipe(
            map((response: any) =>
            {
                return {
                    properties: this.normalizeProperties(response.data.properties),
                    success: response.data.success
                };
            }),
            share());
    }

    public getPropertyById(propertyId: string): Observable<IPropertyResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                PropertyId: propertyId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.PROPERTY.GET_PROPERTY_BY_ID,null, config).pipe(
            map((response: any) =>
            {
                return {
                    property: this.normalizeProperty(response.data.property),
                    propertyId: propertyId,
                    success: response.data.success
                };
            }),
            share());
    }

    public getAllPropertySuites(orgId: string): Observable<IPropertyResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.PROPERTY.GET_SUITES, null, config).pipe(
            map((response: any) =>
            {
                return {
                    propertySuites: this.normalizePropertySuites(response.data.propertySuites),
                    success: response.data.success
                };
            }),
            share());
    }

    public getPropertySuiteById(propertySuiteId: string): Observable<IPropertyResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                PropertySuiteId: propertySuiteId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.PROPERTY.GET_PROPERTY_SUITE_BY_ID, null, config).pipe(
            map((response: any) =>
            {
                return {
                    propertySuite: this.normalizePropertySuite(response.data.propertySuite),
                    propertySuiteId: propertySuiteId,
                    success: response.data.success
                };
            }),
            share());
    }

    public createNewProperty(newProperty: INewProperty): Observable<IPropertyResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PROPERTY.CREATE_PROPERTY, newProperty).pipe(
            map((response: any) =>
            {
                return {
                    properties: this.normalizeProperties(response.data.properties),
                    propertyId: response.data.propertyId,
                    success: response.data.success
                };
            }),
            share());
    }

    public createPropertyContracts(documents: INewPropertyContractDocument): Observable<IPropertyResponse>
    {
        const formdata = createFormData(documents);

        return this.http.post(ServiceEndpointConstants.endpoints.PROPERTY.SAVE_PROPERTY_DOCUMENT, formdata).pipe(
            map((response: any) =>
            {
                return {
                    property: this.normalizeProperty(response.data.property),
                    propertyId: response.data.propertyId,
                    success: response.data.success
                };
            }),
            share());
    }

    public createPropertyRentContracts(documents: INewPropertyRentDocument): Observable<IPropertyResponse>
    {
        const formdata = createFormData(documents);

        return this.http.post(ServiceEndpointConstants.endpoints.PROPERTY.SAVE_PROPERTY_RENT_DOCUMENT, formdata).pipe(
            map((response: any) =>
            {
                return {
                    property: this.normalizeProperty(response.data.property),
                    propertySuiteId: response.data.propertySuiteId,
                    success: response.data.success
                };
            }),
            share());
    }

    public updateProperty(property: IProperty): Observable<IPropertyResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PROPERTY.UPDATE_PROPERTY, property).pipe(
            map((response: any) =>
            {
                return {
                    property: this.normalizeProperty(response.data.property),
                    propertyId: property.propertyId,
                    success: response.data.success
                };
            }),
            share());
    }

    public createPropertySuite(newPropertySuite: IPropertySuite): Observable<IPropertyResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PROPERTY.SAVE_PROPERTY_SUITE, newPropertySuite).pipe(
            map((response: any) =>
            {
                return {
                    property: this.normalizeProperty(response.data.property),
                    propertyId: newPropertySuite.propertyId,
                    success: response.data.success

                };
            }),
            share());
    }

    public updatePropertySuite(propertySuite: IPropertySuite): Observable<IPropertyResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.PROPERTY.UPDATE_PROPERTY_SUITE, propertySuite).pipe(
            map((response: any) =>
            {
                return {
                    property: this.normalizeProperty(response.data.property),
                    propertyId: response.data.property ? response.data.property.propertyId : "",
                    success: response.data.success
                };
            }),
            share());
    }

    private normalizeProperties(properties: any): IProperty[]
    {
        return properties.map(property =>
        {
            return this.normalizeProperty(property);
        });
    }

    private normalizePropertySuites(properties: any): IPropertySuite[]
    {
        return properties.map(property =>
        {
            return this.normalizePropertySuite(property);
        });
    }

    private normalizePropertySuite(property: any): IPropertySuite
    {

        
       // property.propertyDocument = this.normalizePropertyDocuments(property.propertyDocument ? property.propertyDocument : []);


        return property;
    }

    private normalizeProperty(property: any): IProperty
    {
      
        property.propertyId = property.propertyId ? property.propertyId : "";
        property.propertyName = property.propertyName ? property.propertyName : "";

        property.propertyAddressLine1 = property.propertyAddressLine1 ? property.propertyAddressLine1: "";
        property.propertyAddressLine2 = property.propertyAddressLine2 ? property.propertyAddressLine2 : "";
        property.propertyAddressCity = property.propertyAddressCity ? property.propertyAddressCity : "";
        property.propertyAddressState = property.propertyAddressState ? property.propertyAddressState : ""; 
        property.propertyAddressZipCode = property.propertyAddressZipCode ? property.propertyAddressZipCode : "";

        property.propertyDocument = this.normalizePropertyDocuments(property.propertyDocument ? property.propertyDocument : []);


        return property;
    }
    private normalizePropertyDocuments(docs: any): IPropertyContractDocument[]
    {
        return docs.map(doc =>
        {
            return {
                propertyDocumentId: doc.propertyDocumentId,
                propertyDocumentTypeId: doc.propertyDocumentTypeId,
                fileLocationPath: doc.fileLocationPath,
                lastModifyBy: doc.lastModifyBy,
                lastModifyDateTime: doc.lastModifyDateTime,
                fileName: doc.fileName
            };
        });
    }
}